export class Iata {
  constructor(public iataCode: string = null,
              public iataOverride: boolean = false,
              public iataComments: string = null) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/iata.ts